import { Skeleton } from 'ui';

const ChatDetailMessagesSkeleton = () => (
  <Skeleton
    active
    paragraph={{
      rows: 3,
      width: ['60%', '45%', '50%'],
    }}
  />
);

export default ChatDetailMessagesSkeleton;
